// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Wuxsj","content":"styles_content__36jjm","checkbox":"styles_checkbox__Ezp9M","checkboxLabel":"styles_checkboxLabel__3-3DX"};